module.exports = __webpack_public_path__ + "static/media/download-icon.5008ddc2.svg";